{#if show && !container.readonly}
  <Textarea 
    id={id}
    on:click 
    on:change 
    on:focus 
    on:blur
    bind:value={value} 
    font-size="md"
    border="none"
    mt={container.layout==="stacked" ? "nm" : null}
    pt="2px"
    line="20px"
    width= "100%"
    underlined={true}
    bg="transparent"
    focus-bg="light"
  />
{/if}

<script>
  import { Textarea } from 'svelte-stylo';

  export let
    id, 
    container, 
    value, 
    show=true;
</script>
